import { Player } from '@lottiefiles/react-lottie-player';
import PropTypes from 'prop-types';
import React, {memo } from 'react';
import './Wave.scss';
import { useMediaQuery } from '../../utils';

const images = {
	xs: [
		require('../../assets/images/waves-xs/1-BackWave2.json'),
		require('../../assets/images/waves-xs/2-BackWave1.json'),
		require('../../assets/images/waves-xs/3-FrontWave2.json'),
		require('../../assets/images/waves-xs/4-FrontWave1.json')
	],
	sm: [
		require('../../assets/images/waves-sm/1-BackWave2.json'),
		require('../../assets/images/waves-sm/2-BackWave1.json'),
		require('../../assets/images/waves-sm/3-FrontWave2.json'),
		require('../../assets/images/waves-sm/4-FrontWave1.json')
	],
	md: [
		require('../../assets/images/waves-md/1-BackWave2.json'),
		require('../../assets/images/waves-md/2-BackWave1.json'),
		require('../../assets/images/waves-md/3-FrontWave2.json'),
		require('../../assets/images/waves-md/4-FrontWave1.json')
	],
	lg: [
		require('../../assets/images/waves-lg/1-BackWave2.json'),
		require('../../assets/images/waves-lg/2-BackWave1.json'),
		require('../../assets/images/waves-lg/3-FrontWave2.json'),
		require('../../assets/images/waves-lg/4-FrontWave1.json')
	],
	xl: [
		require('../../assets/images/waves-xl/1-BackWave2.json'),
		require('../../assets/images/waves-xl/2-BackWave1.json'),
		require('../../assets/images/waves-xl/3-FrontWave2.json'),
		require('../../assets/images/waves-xl/4-FrontWave1.json')
	],
}

export const Wave = memo(props => {
	const { type } = props;
	const isXs = useMediaQuery('(max-aspect-ratio: 9/16)');
	const isSm = useMediaQuery('(max-aspect-ratio: 9/12)');
	const isMd = useMediaQuery('(max-aspect-ratio: 5/4)');
	const isLg = useMediaQuery('(max-aspect-ratio: 13/9)');
	let size;

	if (isXs) {
		size = 'xs';
	}
	else if (isSm) {
		size = 'sm';
	}
	else if (isMd) {
		size = 'md';
	}
	else if (isLg) {
		size = 'lg';
	}
	else {
		size = 'xl';
	}
	console.log(size)
	const src = images[size][type];
	const extendedClassName = `wave wave-${type}`;

	return (
		<Player
			autoplay
			loop
			speed={1}
			src={src}
			className={extendedClassName}
		/>
	);
});

Wave.propsTypes = {
	type: PropTypes.number,
};
